import { RawLocation } from 'vue-router';

export enum ImageSizes {
  CONTAIN = 'contain',
  COVER = 'cover',
}

export enum CostText {
  FREE = 'Бесплатно'
}

export interface ItemBase {
  id: string;
  code: string;
  title: string;
  note?: string;
  text?: Array<string> | string;
  age?: string | number;
  price?: string | number;
  size?: string | number;
  max_person?: string | number;
  duration?: string | number;
  rate?: boolean;
  rating?: number;
  is_locked?: boolean;
  is_pfdod?: boolean;
  available_order_next_year?: boolean;
  sub_section_significant?: boolean;
  ovz?: boolean;
  target?: false | string;
  variant?: false | Variants;
  deducted?: boolean;
  hideButton?: boolean;
  link?: false | RawLocation;
  imageBgSize?: ImageSizes;
  imageBgColor?: false | string;
  cost?: string | number;
  form_education_id?: string | number;
  is_open?: boolean;
  labor_program?: string | number;
  length?: string | number;
  is_free?: boolean;
}

export interface Item extends ItemBase {
  img: string;
}

export enum Variants {
  RED = 'red',
  GREY = 'grey',
  PURPLE = 'purple',
  ORANGE = 'orange',
  GREEN = 'green',
  DEFAULT = '',
  MAROON = 'maroon',
}



// WEBPACK FOOTER //
// ./src/components/parts/catalog/list/item/types.ts